import produce from 'immer';
import moment from 'moment';
import { IPlaylist, IPlaylistState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import {
  getSorting,
  getStatusId,
  SKYNET_STATES,
  stableSort
} from '../../utilities/utilities';
import { IPlaylistActions } from '../actions/playlistActions';
export const initialPlaylistState: IPlaylistState = {
  playlistIds: [],
  playlistMap: {},
  isFetching: false,
  selectedPlaylist: undefined,
  fetchCount: 0,
  lastFetched: ''
};
const PlaylistReducer = (
  state = initialPlaylistState,
  action: IPlaylistActions
): IPlaylistState => {
  const playlistIds: string[] = [];
  const playlistMap: { [key: string]: IPlaylist } = {}; // Playlist code to Playlist json map

  return produce(state, (draft: IPlaylistState) => {
    switch (action.type) {
      case actionTypes.FETCH_PLAYLISTS_SUCCESS:
        draft.isFetching = false;

        // handling the snooze in the ui
        action.payload = action.payload.map(playlist => {
          if (
            Math.round(
              playlist.end_snooze_at !== 0 && new Date().getTime() / 1000
            ) < playlist.end_snooze_at
          ) {
            return { ...playlist, skynet_status: SKYNET_STATES.SNOOZED };
          } else {
            return playlist;
          }
        });

        action.payload = action.payload.filter(playlist => {
          return playlist.skynet_status;
        });
        // assign the status to the playlist

        action.payload = action.payload.map(playlist => {
          return {
            ...playlist,
            action:
              playlist.issue_tracker_ticket && playlist.issue_tracker_ticket.issue_id
                ? playlist.issue_tracker_ticket.status === 'close'
                  ? 'resolved'
                  : 'escalated'
                : 'escalate',
            statusId: getStatusId(playlist.skynet_status)
          };
        });
        action.payload = stableSort(
          action.payload,
          getSorting('desc', 'statusId')
        );

        action.payload.map((playlist: any, index: number) => {
          playlist.sr_no = index + 1;
          playlistIds.push(playlist.id);
          playlistMap[playlist.id] = playlist;
        });
        draft.playlistIds = playlistIds;
        draft.playlistMap = playlistMap;
        draft.lastFetched = moment().format('HH:mm:ss');

        break;
      case actionTypes.FETCH_PLAYLISTS_REJECT:
        draft.fetchCount = 0;
        draft.playlistIds = [];
        draft.playlistMap = {};
        break;
      case actionTypes.FETCH_PLAYLISTS_PENDING:
        draft.fetchCount += 1;
        draft.isFetching = true;
        break;
      case actionTypes.SELECT_PLAYLIST:
        draft.selectedPlaylist = action.playlistId;
        break;
      case actionTypes.DESELECT_PLAYLIST:
        draft.selectedPlaylist = undefined;
        break;
      case actionTypes.RESET_PLAYLIST_FETCH_COUNT:
        draft.fetchCount = 0;
        break;
      case actionTypes.SNOOZE_PLAYLIST:
        draft.selectedPlaylist = undefined;
        draft.fetchCount = 0;
        break;
      case actionTypes.RESOLVE_PLAYLIST:
        draft.selectedPlaylist = undefined;
        draft.fetchCount = 0;
        break;
      case actionTypes.ESCALATE_PLAYLIST:
        draft.selectedPlaylist = undefined;
        draft.fetchCount = 0;
        break;
    }
  });
};

export default PlaylistReducer;
